import React, {useState} from "react";
import {pageAuthorizedByGroup} from "../fragments/PageAuthorization";
import {Button, Card, Stack, Typography} from "@mui/material";
import {Language, SettingsApplications, Textsms, ViewWeek} from "@mui/icons-material";
import {Link} from "react-router-dom";
import {translateFunction} from "../../localization/TranslationService";

const translate = translateFunction("SureBasePortalTranslations");

/*
* overview
*
* modules
* modules/:id
* phrases
* phrases/:id
* */

export const TranslationsOverview = pageAuthorizedByGroup(function() {
	useState<string>("");
	return <>
		<Stack direction={"row"} justifyContent={"space-evenly"} style={{width: "100%"}}>
			<Card variant={"outlined"} style={{padding: "20px 10px", width: "150px", height: "180px"}}>
				<Stack justifyContent={"space-between"} style={{height: "100%"}}>
					<div style={{textAlign: "center"}}>
						<SettingsApplications fontSize={"large"}/>
						<Typography>{translate("Modules")}</Typography>
					</div>
					<Stack direction={"row-reverse"}>
						<Button component={Link} to={"./modules"}>{translate("Open")}</Button>
					</Stack>
				</Stack>
			</Card>
			<Card variant={"outlined"} style={{padding: "20px 10px", width: "150px", height: "180px"}}>
				<Stack justifyContent={"space-between"} style={{height: "100%"}}>
					<div style={{textAlign: "center"}}>
						<Textsms fontSize={"large"}/>
						<Typography>{translate("Phrases")}</Typography>
					</div>
					<Stack direction={"row-reverse"}>
						<Button component={Link} to={"./phrases"}>{translate("Open")}</Button>
					</Stack>
				</Stack>
			</Card>
			<Card variant={"outlined"} style={{padding: "20px 10px", width: "150px", height: "180px"}}>
				<Stack justifyContent={"space-between"} style={{height: "100%"}}>
					<div style={{textAlign: "center"}}>
						<Language fontSize={"large"}/>
						<Typography>{translate("Translations")}</Typography>
					</div>
					<Stack direction={"row-reverse"}>
						<Button component={Link} to={"./translations"}>{translate("Open")}</Button>
					</Stack>
				</Stack>
			</Card>
			<Card variant={"outlined"} style={{padding: "20px 10px", width: "150px", height: "180px"}}>
				<Stack justifyContent={"space-between"} style={{height: "100%"}}>
					<div style={{textAlign: "center"}}>
						<ViewWeek fontSize={"large"}/>
						<Typography>{translate("Changes")}</Typography>
					</div>
					<Stack direction={"row-reverse"}>
						<Button component={Link} to={"./deploy"}>{translate("Open")}</Button>
					</Stack>
				</Stack>
			</Card>
		</Stack>
	</>;
}, ["Admin", "Translations"]);

export const translationsEditorTargetStage = "kizidev";
